const DEV = "dev.layer.ai";
const DEV2 = "dev2.layer.ai";
const APP = "app.layer.ai";

export interface EnvConfig {
  /** Public PostHog project API key for the matching stack (used for the next-app rollout flag). */
  posthogKey: string;
  nextAppUrl: string;
}

const EnvConfigs: Record<string, EnvConfig> = {
  [DEV]: {
    posthogKey: "phc_A67BeEAAt9CYEeNK3BZZCJRpxYNMo5YxN5M8Hb2DnLMr",
    nextAppUrl: "https://next.dev.layer.ai",
  },
  [DEV2]: {
    posthogKey: "phc_vFaU6kVGSM4duNDgmJYMYrqt6zuDSJXdpdDPknD9HNxb",
    nextAppUrl: "https://next.dev2.layer.ai",
  },
  [APP]: {
    posthogKey: "phc_pw9H5YMECXjh5CctgPMmRzH3nPJxNnVAUXDhCtwwS2Ab",
    nextAppUrl: "https://next.app.layer.ai",
  },
};

export const getEnv = (): EnvConfig => {
  const hostname = window.location.hostname;
  return EnvConfigs[hostname] ?? EnvConfigs[DEV];
};

export const getNextAppLoginUrl = (): string =>
  new URL("/api/auth/login", getEnv().nextAppUrl).toString();
